// KAN-560 (Ricardo 14768): the consent screen's wording for a 13-17 learner (journey age group
// A1, from the birth year: GET /api/consent ``age_group``). Ricardo's text, verbatim. The screen
// comes before the participation gate, which holds the guardian step, and its adult text says
// nothing about a guardian. Straight apostrophe, as in the rest of this screen ("couldn't").
// Adults (and an age not yet known) keep the existing text in ConsentGate.
export const CONSENT_AGE_GROUP_13_17 = 'A1';

export const CONSENT_COPY_13_17 = {
  intro: "Before you start, we need approval from your parent or guardian and your agreement to "
    + "take part. We'll explain what information is saved and how it is used.",
};
